import axios from "axios";
import store from "./state/store";
// import cookie from 'cookiejs';
// import { Swal } from 'sweetalert2/dist/sweetalert2';
// import { swal } from 'vue/types/umd';
import Swal from "sweetalert2";

import router from "./router";

// var token = store.state.currentUser ? store.state.currentUser.token : null;
// var token = sessionStorage.getItem('currentUser') ? JSON.parse(sessionStorage.getItem('currentUser')).token : null;
// console.log('token', token)

// Cache for client IP to avoid repeated calls
let clientIP = null;
let ipFetchPromise = null;

const getClientIP = async () => {
  // Check sessionStorage first (persists across page refresh)
  const storedIP = sessionStorage.getItem("clientIP");
  if (storedIP) {
    clientIP = storedIP;
    return clientIP;
  }

  // Check memory cache
  if (clientIP) {
    return clientIP;
  }

  if (!ipFetchPromise) {
    ipFetchPromise = fetch("/api/client-info")
      .then((response) => response.json())
      .then((data) => {
        clientIP = data.ip;
        // Store in sessionStorage for persistence across page refreshes
        sessionStorage.setItem("clientIP", clientIP);
        return clientIP;
      })
      .catch((error) => {
        console.warn("Failed to get client IP:", error);
        ipFetchPromise = null; // Reset promise on error to allow retry
        return null;
      });
  }

  return ipFetchPromise;
};

const api = axios.create({
  // baseURL: "http://127.0.0.1:3000",
  baseURL: "https://staging.patientlink.digital",
  // baseURL: 'http://18.236.221.227',
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
    // 'Access-Control-Allow-Origin': '*',

    // 'Authorization': "Bearer " + store.state.currentUser ? store.state.currentUser.token : null,
    // 'Access-Control-Allow-Origin': '*',
    // 'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept"
  },
});

// Add a request interceptor
api.interceptors.request.use(async function (config) {
  // const token = store.getters.currentUser ? store.getters.currentUser.token : null;
  const token = sessionStorage.getItem("currentUser")
    ? JSON.parse(sessionStorage.getItem("currentUser")).token
    : null;
  // config.headers.common['Access-Control-Allow-Origin'] = '*';
  // config.headers.common['Access-Control-Allow-Origin'] = '*';
  // config.headers.common['Access-Control-Allow-Origin'] = true;
  // api.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

  config.headers.Authorization = "Bearer " + token;

  // Get client IP (cached after first call)
  const ip = await getClientIP();
  if (ip) {
    config.headers["X-Client-IP"] = ip;
  }
  if (store.getters.currentPractice) {
    config.headers.practiceid = store.getters.currentPractice.id;
    config.headers.practicename = store.getters.currentPractice.name;
    config.headers.practiceDomain = store.getters.currentPractice
      .additionalProp1
      ? store.getters.currentPractice.additionalProp1.url
      : "";
  }
  if (router.history.current.params.categoryName) {
    config.headers.categoryname = router.history.current.params.categoryName;
  }
  // console.log(sessionStorage.getItem('currentUser'))
  return config;
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error);

    if (error.response.status === 401) {
      router.push("/logout");
      if (error.request.responseURL.indexOf("/roles/") === -1) {
        Swal.fire("Session timed out!", "Login again", "warning");
      }
    }
    return Promise.reject(error);
  },
);

export default api;
